import React, { useContext, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import { OnePassword } from "@graylog/enterprise-api";
import { renderOptions } from "../common/Options";
import FormWrap from "../common/FormWrap";
import ValidatedInput from "../common/ValidatedInput";
import formValidation from "../common/utils/formValidation";
const StepAuthorize = ({ onSubmit, onChange }) => {
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { endPoint } = formData;
  const subscriptions = [
    { label: "1Password Business", value: "https://events.1password.com/" },
    { label: "1Password Enterprise", value: "https://events.ent.1password.com/" },
    { label: "1Password EU", value: "https://events.1password.eu/" },
    { label: "1Password CA", value: "https://events.1password.ca/" }
  ];
  const handleSubmit = () => {
    var _a, _b;
    const fetcher = OnePassword.checkCredentials({
      api_token: ((_a = formData == null ? void 0 : formData.apiToken) == null ? void 0 : _a.value) || "",
      end_point: ((_b = formData == null ? void 0 : formData.endPoint) == null ? void 0 : _b.value) || ""
    });
    fetcher.then((result) => {
      if (result.result === "valid") {
        setFormError(null);
        onSubmit();
      } else {
        setFormError({
          full_message: result.result,
          nice_message: "Unable to connect to 1Password using provided configuration."
        });
      }
    }).catch((err) => {
      setFormError({
        full_message: err.message,
        nice_message: "Unable to connect to 1Password using provided configuration."
      });
    });
  };
  const isFormValid = formValidation.isFormValid(["onePasswordName", "apiToken", "endPoint"], formData);
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      className: "col-md-7",
      buttonContent: "Verify Connection & Proceed",
      disabled: isFormValid,
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "onePasswordName",
        type: "text",
        fieldData: formData.onePasswordName,
        onChange,
        placeholder: "Input Name",
        label: "Input Name",
        autoComplete: "off",
        help: "Select a name of your new input that describes it.",
        defaultValue: endPoint == null ? void 0 : endPoint.value,
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "apiToken",
        type: "password",
        fieldData: formData.apiToken,
        onChange,
        label: "API Token",
        help: "The Token to authenticate with 1Password.",
        autoComplete: "off",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        type: "select",
        id: "endPoint",
        onChange,
        fieldData: formData.endPoint,
        help: "1Password account type.",
        required: true,
        label: "Account Type"
      },
      renderOptions(subscriptions, "Choose your 1Password account type", false)
    )
  );
};
export default StepAuthorize;
